module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "collapse.22701181.svg";